import React, { useContext } from 'react';

import SiteSeeContext from './SiteSeeContext';

import { ReactComponent as ZoomOut } from '../Map/MapControls/MapControlsZoom/MobileMapControlsZoomLessIcon.svg';

const SiteSeeZoomOutGuide = () => {
  const { siteSeeName, actionWord } = useContext(SiteSeeContext);

  return (
    <>
      {` ${actionWord} the`}
      <span className="siteSeeGuide__icon siteSeeGuide__icon--inline">
        <ZoomOut />
      </span>
      icon in the
      {' '}
      {siteSeeName}
      {' '}
      control bar below to zoom out and reveal communtiy surroundings.
    </>
  );
};

export default SiteSeeZoomOutGuide;
